// src/hooks/useFloorPlanShiftCorrection.js
//
// Reload sonrasi floor plan origin kaymasini tespit edip tesisat pozisyonlarini
// duzeltir. One-shot: bir kez calisir, flag ile tekrarlanmaz.

import { useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectAllTesisat, updateTesisat } from '../../../redux/tesisatSlice';
import { markFloorPlanShiftCorrected } from '../../../redux/utilsSlice';
import { LOCAL_BUG_TYPES } from '../utils/coordinateHelpers';

export default function useFloorPlanShiftCorrection(scenesRef, tabId, builtRef) {
  const items = useSelector(selectAllTesisat);
  const floorPlanOriginsAtSave = useSelector(state => state.utils?.floorPlanOriginsAtSave || {});
  const shiftCorrected = useSelector(state => state.utils?.floorPlanShiftCorrected || false);
  const layoutCounter = useSelector(state => state.utils?.updateCounter ?? 0);
  const dispatch = useDispatch();
  const correctionAppliedRef = useRef(false);

  useEffect(() => {
    // [SAVE-LOAD-REWRITE] Floor plan shift correction DEVRE DIŞI kalıyor.
    // Save mesh pos'unu olduğu gibi kaydediyor → correction'a gerek yok.
    // Eski JBZ formatları için olan correction artık geçersiz.
    //
    // const scene = scenesRef?.current?.[tabId];
    // if (!scene || shiftCorrected || correctionAppliedRef.current) return;
    // if (!floorPlanOriginsAtSave || Object.keys(floorPlanOriginsAtSave).length === 0) return;
    //
    // let anyFp = false;
    // scene.traverse(o => {
    //   if (!anyFp && o.userData?.floorPlanId && o.userData?.docName === 'Kat Planı') anyFp = true;
    // });
    // if (!anyFp) return;
    //
    // for (const [fpId, savedOrigin] of Object.entries(floorPlanOriginsAtSave)) {
    //   let currentOrigin = null;
    //   scene.traverse(o => {
    //     const ud = o.userData;
    //     if (!currentOrigin && ud?.floorPlanId === fpId && ud?.docName === 'Kat Planı') {
    //       o.updateMatrixWorld(true);
    //       const m = o.matrixWorld.elements;
    //       currentOrigin = { x: m[12], y: m[13] };
    //     }
    //   });
    //   if (!currentOrigin) continue;
    //   const dx = currentOrigin.x - savedOrigin.x;
    //   const dy = currentOrigin.y - savedOrigin.y;
    //   if (Math.abs(dx) < 0.001 && Math.abs(dy) < 0.001) continue;
    //
    //   for (const item of items) {
    //     if (item.floorPlanId !== fpId) continue;
    //     if (!item._v && LOCAL_BUG_TYPES.includes(item.type)) continue;
    //     dispatch(updateTesisat({
    //       id: item.id,
    //       changes: {
    //         position: {
    //           x: (item.position?.x ?? 0) + dx,
    //           y: (item.position?.y ?? 0) + dy,
    //           z: item.position?.z ?? 0,
    //         },
    //       },
    //     }));
    //     const mesh = builtRef.current?.get(item.id);
    //     if (mesh) { mesh.position.x += dx; mesh.position.y += dy; }
    //   }
    // }
    // correctionAppliedRef.current = true;
    // dispatch(markFloorPlanShiftCorrected());
  }, [scenesRef, tabId, items, floorPlanOriginsAtSave, shiftCorrected, layoutCounter, dispatch, builtRef]);
}
